import React from 'react';
import { Link } from 'react-router'
import areasIcon from './images/therapy_areas_resource.svg'
import videosIcon from './images/videos_resource.svg'
import './styles/Resources.scss'

const rowStyle = {
  'justifyContent': 'center'
}



const ResourcesMenu = (props) => {
  const { active, show_videos } = props;
  // console.log(props)

  return <div className="row resources-menu" style={rowStyle}>
    <Link to="/page/therapy_areas"  className={active === 'areas' && 'active'}>
      <img alt="Therapy areas" src={areasIcon} />
      <caption><nobr>Therapy Areas</nobr></caption>
    </Link>
    { show_videos ? (
      <Link  to="/page/videos" className={active === 'videos' && 'active'}>
        <img alt="Videos" src={videosIcon} />
        <caption><nobr>Videos</nobr></caption>
      </Link>) : null
    }
  </div>
}

ResourcesMenu.defaultProps = {
  active: 'areas'
}

export default ResourcesMenu;



// WEBPACK FOOTER //
// ./src/components/home/ResourcesMenu.jsx